/** How the patient was identified at administration, from the saved mode and skip; null for older administrations. */
export function getPatientCheck(mode, patientScanSkipped) {
    if (mode === 'MANUAL')
        return 'manual_mode';
    if (mode === 'SCAN')
        return patientScanSkipped ? 'skipped' : 'scanned';
    return null;
}
/** Lots per trade name and prescription: picked batches of the substance, carrier and solvent, and rest vials by their batch. */
function lotsByTradeName(orders, batches) {
    const lots = new Map();
    const add = (sequenceId, batchId) => {
        const batch = batches.find(row => row.id === batchId);
        if (!batch?.tradeNameId)
            return;
        const key = `${sequenceId}:${batch.tradeNameId}`;
        lots.set(key, (lots.get(key) ?? new Set()).add(batch.lotNumber));
    };
    for (const order of orders) {
        for (const part of [order.activeSubstances, order.carrier, order.solvents]) {
            for (const { batchId } of part.batches)
                add(order.sequenceId, batchId);
        }
        for (const restVial of order.restVials)
            add(order.sequenceId, restVial.batchId);
    }
    return lots;
}
const joinLots = (lots) => (lots?.size ? [...lots].toSorted().join(', ') : null);
/** One item per trade name whose suggested lots were switched on the picking list. */
export function pickingSourceItems(initial, chosen, batches, tradeNames) {
    if (!initial?.length)
        return [];
    const before = lotsByTradeName(initial, batches);
    const after = lotsByTradeName(chosen, batches);
    const items = [];
    for (const key of new Set([...before.keys(), ...after.keys()])) {
        const old = joinLots(before.get(key));
        const next = joinLots(after.get(key));
        if (old === next)
            continue;
        const tradeNameId = key.slice(key.indexOf(':') + 1);
        const label = tradeNames.find(row => row.id === tradeNameId)?.name ?? '-';
        items.push({ field: 'source', label, old, new: next });
    }
    return items;
}
//# sourceMappingURL=production-log-items.js.map